import {
  SessionsOverviewResponse,
  Top10,
  Top10Row,
} from "../apiResponses/sessionsOverviewResponse";
import { Table, Card, Select, Box, Skeleton, Group, Text } from "@mantine/core";
import HamburgerIcon from "../assets/icons/HamburgerIcon";
import React from "react";
import { formatSecs } from "../utils/time";
import { countTypeToTitle } from "../utils/countTypes";
import NoRecordsIcon from "../assets/icons/NoRecordsIcon";

interface Top10CardProps {
  countType: string;
  onChange: (value: any) => void;
  onTitleSelect: (value: Top10Row) => void;
  top10: Top10 | null;
  selectedTitle: string | undefined;
  allowChange?: boolean;
}

const TRANSPARENT_PURPLE = "#BD6DFF1A";

// need to add an onChange callback to the Select component
const Top10Card: React.FC<Top10CardProps> = ({
  onChange,
  onTitleSelect,
  countType,
  top10,
  selectedTitle,
  allowChange,
}) => {
  const t = countTypeToTitle(countType);

  let rows: JSX.Element[];
  if (top10 !== null) {
    if (top10.rows.length === 0) {
      const color = "#807B75";
      rows = [
        <Table.Tr key={0}>
          <Table.Td colSpan={2} align="center">
            <br />
            <NoRecordsIcon color={color} />
            <br />
            <Text color={color} size="sm">
              No records
            </Text>
            <br />
          </Table.Td>
        </Table.Tr>,
      ];
    } else {
      rows = top10.rows.map((row, i) => (
        <Table.Tr
          key={`${i}-${row.title}`}
          bg={selectedTitle === row.title ? TRANSPARENT_PURPLE : undefined}
        >
          <Table.Td onClick={() => onTitleSelect(row)}>
            {ellipsis(row.title, 100)}
          </Table.Td>
          <Table.Td align="right">
            {top10.count_type === "playout_secs"
              ? formatSecs(row.count)
              : row.count}
          </Table.Td>
        </Table.Tr>
      ));
    }
  } else {
    rows = [];
    for (let i = 0; i < 10; i++) {
      rows.push(
        <Table.Tr key={i}>
          <Table.Td>
            <Skeleton width={250} height={20} />
          </Table.Td>
          <Table.Td align="right">
            <Skeleton width={50} height={20} />
          </Table.Td>
        </Table.Tr>,
      );
    }
  }

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder w="100%">
      <Table striped highlightOnHover={true}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th pr={0}>
              <Group justify="space-between">
                <div>
                  <HamburgerIcon /> &nbsp; Titles / Content{" "}
                </div>
                {allowChange ? <div>By</div> : null}
              </Group>
            </Table.Th>
            <Table.Th align="center">
              {allowChange ? (
                <Select
                  value={t}
                  data={["Sessions", "Unique Viewers", "Hours Streamed"]}
                  onChange={onChange}
                />
              ) : (
                <Group justify="end">{t}</Group>
              )}
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Card>
  );
};

export const ellipsis = (s: string, n: number) => {
  if (s.length <= n) {
    return s;
  }
  if (s.indexOf(" ") !== -1) {
    return s;
  }
  return s.substring(0, n - 3) + "...";
};

export default Top10Card;
